import api from "../api";

export const submitApplication = async (data: any[]) => {
  return api.post(`/Employee/CompletePortfolio`, data);
};
